import {inject, injectable} from "inversify";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {AIQualityLevelEnum} from "@/modules/ai/enums";
import {LineupperInterface, TransferDeciderInterface} from "@/modules/ai/interfaces";
import {Application} from "@/di";

@injectable()
export default class AIServiceProvider {
  constructor(
    @inject(Application) private app: Application,
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
  }

  public getLineupper(aiQualityLevel: AIQualityLevelEnum): LineupperInterface {
    return this.app.get(
      this.getConfig(aiQualityLevel).lineupper
    );
  }

  public getTransferDecider(aiQualityLevel: AIQualityLevelEnum): TransferDeciderInterface {
    return this.app.get(
      this.getConfig(aiQualityLevel).transferDecider
    );
  }

  private getConfig(aiQualityLevel: AIQualityLevelEnum) {
    return this.configRepository.get('ai.services')[aiQualityLevel];
  }
}
